<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>신규 비방사전 신청서</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">기본 정보</h3>
          <table class="write">
            <colgroup>
              <col style="width: 200px;" />
              <col style="width: 30%;" />
              <col style="width: 200px;" />
              <col style="width: 30%;" />
            </colgroup>
            <tbody>
              <tr>
                <th><span class="emp">처방명</span></th>
                <td>
                  <input
                      type="text"
                      class="form_control"
                      placeholder="입력해주세요"
                      v-model="scretPrescriptionInfo.prescribe_nm"
                  />
                </td>
                <th>등록자</th>
                <td><span>{{ nick_nm }}</span></td>
              </tr>
              <tr>
                <th><span class="emp">질병 카테고리</span></th>
                <td>
                  <div class="form_select">
                    <b-form-select v-model="scretPrescriptionInfo.prescribe_category">
                      <b-form-select-option value="">선택</b-form-select-option>
                      <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                    </b-form-select>
                  </div>
                </td>
                <th><span class="emp">질병 상세 카테고리</span></th>
                <td>
                  <div class="form_select">
                    <b-form-select v-model="scretPrescriptionInfo.prescribe_dtl_category" >
                      <b-form-select-option value="">선택</b-form-select-option>
                      <b-form-select-option v-for="(item, index) in prescrbeDtlCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                    </b-form-select>
                  </div>
                </td>
              </tr>
              <tr>
                <th>출처</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="scretPrescriptionInfo.prescribe_source"
                  />
                </td>
                <td colspan="2">
                  <small class="txt_info" >
                    &#8251; 비방 출처 및 출전을 입력해주세요. (예 :
                    ‘제우스한의원’ ) 모르거나 없는 경우 ‘모름’ 또는 ‘임상방’으로
                    기재해주세요.
                  </small>
                </td>
              </tr>
              <tr>
                <th><span class="emp">적응증</span></th>
                <td colspan="3">
                  <div class="flex gap4 items-center">
                    <input type="text" class="form_control" v-model="scretPrescriptionInfo.indications1"/>
                    <input type="text" class="form_control" v-model="scretPrescriptionInfo.indications2"/>
                    <input type="text" class="form_control" v-model="scretPrescriptionInfo.indications3"/>
                    <input type="text" class="form_control" v-model="scretPrescriptionInfo.indications4"/>
                    <input type="text" class="form_control" v-model="scretPrescriptionInfo.indications5"/>
                  </div>
                  <small class="txt_info">
                    &#8251; 적응증은 처방을 이용합에 있어서 검색에 용이한 질환명
                    이나 관련 질환 키워드를 입력해주세요. 최소 1개이상 기재.
                    관련 키워드가 많을수록 검색이 더 잘됩니다.
                  </small>
                </td>
              </tr>
              <tr>
                <th>사용 기준</th>
                <td colspan="3">
                  <div class="flex gap8 items-center">
                    <input
                      type="text"
                      class="form_control"
                      style="width: 100px"
                      v-model="scretPrescriptionInfo.usage_criteria_day"
                    />
                    일분
                    <input
                      type="text"
                      class="form_control"
                      style="width: 100px"
                      v-model="scretPrescriptionInfo.usage_criteria_dose"
                    />
                    첩
                    <input
                      type="text"
                      class="form_control"
                      style="width: 100px"
                      v-model="scretPrescriptionInfo.usage_criteria_pack"
                    />
                    팩
                    <input
                      type="text"
                      class="form_control"
                      style="width: 100px"
                      v-model="scretPrescriptionInfo.usage_criteria_unit"
                    />
                    ml
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <div class="table_option">
            <div class="form_select">
              <h3 class="tb_title">처방 환자 예상 몸상태값</h3>
            </div>
          </div>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr v-for="(item, idx) in healthSymptoms" :key="idx">
                <th>
                  <span :class="item.require ? 'emp' : '' ">
                      {{ item.th }}
                  </span>
                </th>
                <td colspan="3">
                  <div class="suggest_list">
                    <b-form-checkbox-group
                        v-if="item.mode === 'select'"
                        @change="(evt) => onChangeLabel(evt, item, idx)"
                        v-model="item.selected"
                        :options="item.data"
                        name="checkbox"
                        buttons
                    />
                    <b-form-radio-group
                        v-else
                        @change="(evt) => onChangeLabel(evt, item, idx)"
                        v-model="item.selected"
                        :options="item.data"
                        name="radios-btn-default"
                        buttons
                    >
                    </b-form-radio-group>
                    <span class="ml20" v-if="item.desc !== ''">※ {{item.desc}}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <div class="table_option">
            <div class="form_select">
              <h3 class="tb_title">비방사전 약재</h3>
            </div>
            <button class="btn btn_md btn_blue" v-b-modal.medicineSearch>약재 추가</button>
          </div>
          <table class="list no_view">
            <colgroup>
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
            </colgroup>
            <thead>
              <tr>
                <th>약재명</th>
                <th>이명</th>
                <th>설명</th>
                <th>용량</th>
                <th>처리</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in medicineList"
                :key="index"
                :class="item.med_hrb_cd === '' ? 'error' : ''"
              >
                <td>
                  <span>{{ item.med_hrb_nm }}</span>
                </td>
                <td>
                  <span>{{ item.med_alias }}</span>
                </td>
                <td>
                  <span>{{ item.med_prfm }}</span>
                </td>
                <td>
                  <div class="form_inline">
                    <input
                      type="text"
                      placeholder="입력하세요"
                      class="form_control"
                      v-model="item.med_use_qnty"
                    />
                  </div>
                </td>
                <td>
                  <div class="flex justify-center">
                    <button class="bdge" @click="fn_medList_delete(index)">삭제</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">추가 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>비방에 대한 설명 및 가감</th>
                <td colspan="3">
                  <textarea
                    class="form_control"
                    placeholder="비방에 대한 설명을 기재해주세요. 자세한 설명을 기재할수록 좋습니다."
                    style="min-height: 200px"
                    v-model="scretPrescriptionInfo.secret_prescription_adjust"
                  >
                  </textarea>
                </td>
              </tr>
              <tr>
                <th>참고사항</th>
                <td colspan="3">
                  <textarea
                    class="form_control"
                    placeholder="처방을 사용함에 있어서 주의사항이나 부작용 등 참고사항을 기재해주세요."
                    style="min-height: 200px"
                    v-model="scretPrescriptionInfo.remarks"
                  >
                  </textarea>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="bottom_box bn">
            <button class="btn btn_md btn_darkbrown" @click="$router.go(-1)">
              목록
            </button>
            <button v-if="this.status == 'M'" class="btn btn_md btn_brown" @click="fn_save">재등록하기</button>
            <button v-else class="btn btn_md btn_brown" @click="fn_save">비방등록 신청하기</button>
          </div>
        </div>
      </article>
    </section>
    <SearchModal 
        :title="'약재 검색'" 
        :searchName="'약재명'"
        :oneBtn="true"
        :btnLeft="'적용'" 
        :btnRight="'닫기'"
        @callback="fn_callback"
      />
      <alert-modal 
        :id="'alert'"
        :text="showAlertMsg" 
        :btnRight="'확인'" 
        :oneBtn="false"
        :isShow="showAlert"
        :className="'btn_brown'"
        :closeEventValue="closeEventValue"
        @closeEvent="oncCloseEvent"
        v-on:update:showSetting="fn_showSet"
      />
      <alert-modal 
        :id="'confirm'"
        :text="'저장하시겠습니까?'" 
        :btnLeft="'취소'" 
        :btnRight="'확인'" 
        :oneBtn="true"
        :isShow="comfirmAlertShow"
        :className="'btn_brown'"
        @callback="fn_alert_close"
      />
  </div>
</template>

<script>

import axios from 'axios'
import SearchModal from "@/modal/admin/medicineSearch.vue"
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";
import commonUtil from "@/mixin/commonUtil";
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: {
    SearchModal,
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      secret_prescription_seq : '',
      clinic_doctor_id : '',
      doctor_nm : '',
      nick_nm : '',
      scretPrescriptionInfo : {
        secret_prescription_seq : '',
        clinic_doctor_id : '',
        prescribe_nm : '',
        prescribe_category : '',
        prescribe_dtl_category : '',
        prescribe_source : '',
        indications1 : '',
        indications2 : '',
        indications3 : '',
        indications4 : '',
        indications5 : '',
        usage_criteria_day : '',
        usage_criteria_dose : '',
        usage_criteria_pack : '',
        usage_criteria_unit : '',
        secret_prescription_adjust : '',
        remarks : '',
        gender : '',
        constitutionImpact : '',
        constitution : '',
        thermalType : [],
        physicalStatus : '',
        tensionStatus : '',
        sensitivity : '',
        thirstStatus : [],
        sleepStatus : [],
        bowelStatus : '',
        residualStoolSense : '',
        digestiveStatus : [],
        appetite : '',
        status : ''
      },
      medicineList : [],
      prescrbeCategoryList : [],
      prescrbeDtlCategoryList : [],
      status : '',
      comfirmAlertShow : false,
      genderList : [],
      physicalConditionList : [],
      thirstStatusList : [],
      tensionLevelList : [],
      sleepStatusList : [],
      bowelStatusList : [],
      appetiteStatusList  : [],
      constitutionImpactList : [],
      constitutionList : [],
      thermalTypeList : [],
      sensitivityList : [],
      residualStoolSenseList : [],
      healthSymptoms : [],
      digestiveStatusList : []
    };
  },
  watch: {
    async 'scretPrescriptionInfo.prescribe_category'(newVal) {

      if (!newVal) return;

      const list = await this.getDtlCode('GC00000015',newVal);
      this.prescrbeDtlCategoryList = list || [];

      if(this.prescrbeDtlCategoryList.some(item => item.dtl_code === this.scretPrescriptionInfo.prescribe_detail_category)){
        this.scretPrescriptionInfo.prescribe_dtl_category = this.scretPrescriptionInfo.prescribe_detail_category;
      }else{
        this.scretPrescriptionInfo.prescribe_dtl_category = '';
      }

    }
  },
  computed: {
    healthCheck() {

      //데이터 가공

      let genderList = this.genderList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

       let physicalList = this.physicalConditionList.map(item => ({
         value: item.dtl_code,
         text: item.dtl_code_nm,
         disabled: false
       }));

      let tensionList = this.tensionLevelList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let thirstlList = this.thirstStatusList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let sleepList = this.sleepStatusList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let bowelList = this.bowelStatusList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let AppetitelList = this.appetiteStatusList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let constitutionImpactList = this.constitutionImpactList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let constitutionList = this.constitutionList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: true
      }));

      let thermalTypeList = this.thermalTypeList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let residualStoolSenseList = this.residualStoolSenseList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let sensitivityList = this.sensitivityList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      let digestiveStatusList = this.digestiveStatusList.map(item => ({
        value: item.dtl_code,
        text: item.dtl_code_nm,
        disabled: false
      }));

      return [
        { th: '성별', require: true, data: genderList, selected: '', label: '', etcMsg: '' ,desc : ''},
        { th: '체질과의 연관성', require: true, data: constitutionImpactList, selected: '', label: '', etcMsg: '',desc : '' },
        { th: '사상체질', require: false, data: constitutionList, selected: '', label: '', etcMsg: '',desc : '체질영향 선택시 선택가능' },
        { th: '한열타입', require: true, data: thermalTypeList, selected: [], label: '', etcMsg: '', mode: 'select', desc: '한성+중간, 중간+열성 복수선택 가능' },
        { th: '체력상태', require: true, data: physicalList, selected: '', label: '', etcMsg: '',desc : '' },
        { th: '긴장상태', require: true, data: tensionList, selected: '', label: '', etcMsg: '' ,desc : ''},
        { th: '예민도', require: true, data: sensitivityList, selected: '', label: '', etcMsg: '' ,desc : '' },
        { th: '갈증상태', require: true, data: thirstlList, selected: [], label: '', etcMsg: '', mode: 'select', desc: '보통+갈증적음, 보통+갈증많음 인접 복수선택 가능' },
        { th: '수면상태', require: true, data: sleepList, selected: [], label: '', etcMsg: '', mode: 'select' ,desc : '양호,모름 이외 복수선택 3개 가능'},
        { th: '대변상태', require: true, data: bowelList, selected: '', label: '', etcMsg: '',desc : '' },
        { th: '잔변감', require: false, data: residualStoolSenseList, selected: [], label: '', etcMsg: '' ,desc : ''},
        { th: '소화상태', require: false, data: digestiveStatusList, selected: [], label: '', etcMsg: '', mode: 'select', desc: '상관없음 이외 복수선택 2개 가능' },
        { th: '식욕상태', require: true, data: AppetitelList, selected: '', label: '', etcMsg: '' ,desc : ''},
      ];
    }
  },
  async created(){

    this.secret_prescription_seq = this.$store.getters['detailSearchInfo/getSearchId'];
    this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    this.doctor_nm = this.$store.getters['clinicDoctorInfo/getDoctorNm'];
    this.nick_nm = this.$store.getters['clinicDoctorInfo/getNickNm'];
    this.scretPrescriptionInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    this.status = this.$store.getters['detailSearchInfo/getStatus'];

    console.log("@@@@@@ reg secret_prescription_seq: %o",this.secret_prescription_seq);
    console.log("@@@@@@ reg status: %o",this.status);

  },
  async mounted(){
    await this.fn_init_list();
    await this.$nextTick();


    if(this.status == 'M'){
        this.fn_search() 
    }

    this.healthSymptoms = cloneDeep(this.healthCheck);
  },
  methods : {
    async fn_init_list(){

      const codeList = await this.getCodeList([
        'GC00000003',
        'GC00000015',
        'GC00000030',
        'GC00000031',
        'GC00000032',
        'GC00000033',
        'GC00000034',
        'GC00000035',
        'GC00000036',
        'GC00000037',
        'GC00000038',
        'GC00000039',
        'GC00000040',
        'GC00000045',
      ]);

      this.genderList = codeList['GC00000003'] || [];
      this.prescrbeCategoryList = codeList['GC00000015'] || [];
      this.physicalConditionList  =  codeList['GC00000030'] || [];
      this.tensionLevelList  = codeList['GC00000031'] || [];
      this.thirstStatusList  = codeList['GC00000032'] || [];
      this.sleepStatusList  = codeList['GC00000033'] || [];
      this.bowelStatusList  =  codeList['GC00000034'] || [];
      this.appetiteStatusList   = codeList['GC00000035'] || [];
      this.constitutionImpactList = codeList['GC00000036'] || [];
      this.constitutionList = codeList['GC00000037'] || [];
      this.thermalTypeList = codeList['GC00000038'] || [];
      this.sensitivityList = codeList['GC00000039'] || [];
      this.residualStoolSenseList =  codeList['GC00000040'] || [];
      this.digestiveStatusList =  codeList['GC00000045'] || [];
    },
    fn_search(){

        //환자seq 정보 셋팅
        let param = new Object();
        param.secret_prescription_seq = this.secret_prescription_seq;
        param.clinic_doctor_id = this.clinic_doctor_id;

        //내 비방 정보 상세조회
        axios
            .post("/api/user/hanidata/getMyFormulaLibraryDetail", param)
            .then((res) => {

              //결과값 merge 해서 셋팅 (기존값 유지하면서 업데이트된 값만 변경)
              this.scretPrescriptionInfo = merge(
                  {},
                  cloneDeep(this.scretPrescriptionInfo),
                  cloneDeep(res.data.myFormulaLibraryInfo)
              );

              console.log("@@@@ merged scretPrescriptionInfo : %o", this.scretPrescriptionInfo);

              // 기존 데이터와 API에서 받은 데이터를 병합하여 필요한 필드 가공
              this.scretPrescriptionInfo.bowelStatus = this.scretPrescriptionInfo.bowel_status;
              this.scretPrescriptionInfo.physicalStatus = this.scretPrescriptionInfo.physical_condition;
              this.scretPrescriptionInfo.thirstStatus = this.scretPrescriptionInfo.thirst_status_codes
                ? this.scretPrescriptionInfo.thirst_status_codes.split(',')
                : (this.scretPrescriptionInfo.thirst_status ? [this.scretPrescriptionInfo.thirst_status] : []);
              this.scretPrescriptionInfo.thermalType = this.scretPrescriptionInfo.thermal_status_codes ? this.scretPrescriptionInfo.thermal_status_codes.split(',') : [];
              this.scretPrescriptionInfo.tensionStatus = this.scretPrescriptionInfo.tension_status;

              this.scretPrescriptionInfo.sensitivity = this.scretPrescriptionInfo.sensitivity;

              this.scretPrescriptionInfo.modeState = this.scretPrescriptionInfo.mode_status_codes ? this.scretPrescriptionInfo.mode_status_codes.split(',') : [];
              this.scretPrescriptionInfo.sleepStatus = this.scretPrescriptionInfo.sleep_status_codes ? this.scretPrescriptionInfo.sleep_status_codes.split(',') : [];
              this.scretPrescriptionInfo.digestiveStatus = this.scretPrescriptionInfo.digestive_status_codes
                ? this.scretPrescriptionInfo.digestive_status_codes.split(',')
                : (this.scretPrescriptionInfo.digestive_status ? [this.scretPrescriptionInfo.digestive_status] : []);

              this.medicineList = cloneDeep(res.data.medicineList) || [];

              this.medicineList.forEach(item => {
                item.med_use_qnty = item.medicine_use_qnty || '';
              });

              //환자 증상 버튼 선택 및 라벨 셋팅
              this.healthSymptoms[0].selected = this.scretPrescriptionInfo.gender;
                this.healthSymptoms[0].label = this.scretPrescriptionInfo.gender_nm;
              this.healthSymptoms[1].selected = this.scretPrescriptionInfo.constitutionImpact;
                this.healthSymptoms[1].label = this.scretPrescriptionInfo.constitutionImpact_nm;
              this.healthSymptoms[2].selected = this.scretPrescriptionInfo.constitution;
                this.healthSymptoms[2].label = this.scretPrescriptionInfo.constitution_nm;
              this.healthSymptoms[3].selected = Array.isArray(this.scretPrescriptionInfo.thermalType)
                ? this.scretPrescriptionInfo.thermalType
                : (this.scretPrescriptionInfo.thermalType ? this.scretPrescriptionInfo.thermalType.split(',') : []);
                this.healthSymptoms[3].label = this.scretPrescriptionInfo.thermalType_nm;
              this.healthSymptoms[4].selected = this.scretPrescriptionInfo.physicalStatus;
                this.healthSymptoms[4].label = this.scretPrescriptionInfo.physicalStatus_nm;
              this.healthSymptoms[5].selected = this.scretPrescriptionInfo.tensionStatus;
                this.healthSymptoms[5].label = this.scretPrescriptionInfo.tension_status_nm;
              this.healthSymptoms[6].selected = this.scretPrescriptionInfo.sensitivity;
                this.healthSymptoms[6].label = this.scretPrescriptionInfo.sensitivity_nm;
              this.healthSymptoms[7].selected = Array.isArray(this.scretPrescriptionInfo.thirstStatus)
                ? this.scretPrescriptionInfo.thirstStatus
                : (this.scretPrescriptionInfo.thirstStatus ? this.scretPrescriptionInfo.thirstStatus.split(',') : []);
                this.healthSymptoms[7].label = this.scretPrescriptionInfo.thirst_status_nm;
              this.healthSymptoms[8].selected = this.scretPrescriptionInfo.sleepStatus;
                this.healthSymptoms[8].label = this.scretPrescriptionInfo.sleep_status_nm;
              this.healthSymptoms[9].selected = this.scretPrescriptionInfo.bowelStatus;
                this.healthSymptoms[9].label = this.scretPrescriptionInfo.bowel_status_nm;
              this.healthSymptoms[10].selected = this.scretPrescriptionInfo.residualStoolSense;
                this.healthSymptoms[10].label = this.scretPrescriptionInfo.residual_stool_sense_nm;
              this.healthSymptoms[11].selected = Array.isArray(this.scretPrescriptionInfo.digestiveStatus)
                ? this.scretPrescriptionInfo.digestiveStatus
                : (this.scretPrescriptionInfo.digestiveStatus ? this.scretPrescriptionInfo.digestiveStatus.split(',') : []);
                this.healthSymptoms[11].label = this.scretPrescriptionInfo.digestive_status_nm;
              this.healthSymptoms[12].selected = this.scretPrescriptionInfo.appetite;
                this.healthSymptoms[12].label = this.scretPrescriptionInfo.appetite_nm;

              //사상체질 버튼 활성화
              if(this.scretPrescriptionInfo.constitutionImpact === 'A') {
                this.healthSymptoms[2].data.forEach(item => item.disabled = false);
              }

            })
            .catch((err) => console.log(err));
            
    },
    fn_save(){
      this.scretPrescriptionInfo.status = this.status;

      //validation 체크
        if(this.scretPrescriptionInfo.prescribe_nm == ''){
            let msg = "처방명을 입력해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.prescribe_category == ''){
            let msg = "질병 카테고리를 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

       if(this.scretPrescriptionInfo.prescribe_dtl_category == ''){
              let msg = "질병 상세 카테고리를 선택해주세요.";
              this.fn_open_alert(msg);
              return;
        }

        if(this.scretPrescriptionInfo.indications1 == '' && this.scretPrescriptionInfo.indications2 == '' && this.scretPrescriptionInfo.indications3 == '' && this.scretPrescriptionInfo.indications4 == '' && this.scretPrescriptionInfo.indications5 == ''){
              let msg = "적응중을 최소 1개이상 입력해주세요.";
              this.fn_open_alert(msg);
              return;
        }


         if(this.healthSymptoms.some(item => item.require && (item.selected === '' || (Array.isArray(item.selected) && item.selected.length === 0)))){
              let msg = "필수 환자 증상을 모두 입력해주세요.";
              this.fn_open_alert(msg);
              return;
        }

        if(this.medicineList.length == 0){
              let msg = "비방사전에 포함된 약재를 1개이상 등록해주세요.";
              this.fn_open_alert(msg);
              return;
        }

        if(this.medicineList.some(item => !item.med_use_qnty || Number(item.med_use_qnty) === 0)){
              let msg = "약재 용량을 입력해주세요.";
              this.fn_open_alert(msg);
              return;
        }

        if(this.scretPrescriptionInfo.gender === ''){
            let msg = "성별을 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.constitutionImpact === ''){
            let msg = "체질과의 연관성을 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }else{
            if(this.scretPrescriptionInfo.constitutionImpact === 'A' && this.scretPrescriptionInfo.constitution === ''){
                let msg = "사상체질을 선택해주세요.";
                this.fn_open_alert(msg);
                return;
            }
        }

        if(this.scretPrescriptionInfo.thermalType.length === 0){
            let msg = "한열타입을 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.physicalStatus === ''){
            let msg = "체력상태를 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.tensionStatus === ''){
            let msg = "긴장상태를 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.modeState === ''){
            let msg = "예민도를 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.thirstStatus.length === 0){
            let msg = "갈증유무를 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.sleepStatus.length === 0){
            let msg = "수면상태를 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.bowelStatus === ''){
            let msg = "대변상태를 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

        if(this.scretPrescriptionInfo.appetite === ''){
            let msg = "식욕상태를 선택해주세요.";
            this.fn_open_alert(msg);
            return;
        }

      this.comfirmAlertShow = true;
    },
    fn_alert_close(type){

      this.comfirmAlertShow = false;
                    
      if(type == 'ok'){

        let param = new Object();
        param.scretPrescriptionInfo = this.scretPrescriptionInfo;
        param.medicineList = this.medicineList;

        console.log("@@@@ param : %o",param);

        axios.post("/api/user/hanidata/regMyFormulaLibrary", param)
          .then((res) => {
                console.log("@@@@ res : %o",res);

                let msg = "저장되었습니다.";
                this.fn_open_alert_close(msg);

            })
            .catch((err) => console.log(err));
      }

    },
    fn_callback (medObject){
      medObject.use_qy = 0;
      this.medicineList.push(medObject);            
    },
    fn_medList_delete(idx){
      this.medicineList.splice(idx, 1);
    },
    fn_move_listPage(){
      this.$store.dispatch('detailSearchInfo/setSearchId', '');
      this.$store.dispatch('detailSearchInfo/setStatus', '');
      this.$router.push("/hanidata/myFormulaLibraryList");
    },
    oncCloseEvent(){
        this.fn_move_listPage();
    },
    onChangeLabel (evt, row, idx) {
      console.log("@@@@@@ typeof evt : %o", typeof evt);

      // 체크박스는 evt가 Object로 넘어오고 라디오버튼은 String이 넘어옴
      if (typeof evt === 'object') {

        // 한열타입: 상열하한/상관없음/판단안됨은 단독선택, 그 외에는 중간을 포함한 조합만 복수선택 허용
        if(idx === 3){
          const EXCLUSIVE_TEXTS = ['상열하한', '상관없음', '판단안됨'];
          const exclusiveValues = row.data.filter(d => EXCLUSIVE_TEXTS.includes(d.text)).map(d => d.value);
          const anchorValue = (row.data.find(d => d.text === '중간') || {}).value;
          const last = evt[evt.length - 1];

          if(exclusiveValues.includes(last)){
            row.selected = [last];
          } else {
            let candidate = evt.filter(v => !exclusiveValues.includes(v));
            if(candidate.length > 2){
              const lastCandidate = candidate[candidate.length - 1];
              candidate = (anchorValue !== undefined && lastCandidate !== anchorValue && candidate.includes(anchorValue))
                ? [anchorValue, lastCandidate]
                : [lastCandidate];
            } else if(candidate.length === 2 && !candidate.includes(anchorValue)){
              candidate = [candidate[candidate.length - 1]];
              //this.fn_open_alert('한성+중간 또는 중간+열성만 복수 선택이 가능합니다.');
            }
            row.selected = candidate;
          }
          const itemMap = row.data.reduce((map, item) => { map[item.value] = item.text; return map; }, {});
          this.healthSymptoms[idx].label = row.selected.map(v => itemMap[v]).join('+');
        }
        // 갈증상태: 상관없음은 단독선택, 그 외에는 보통을 포함한 조합만 복수선택 허용
        else if(idx === 7){
          const exclusiveValue = (row.data.find(d => d.text === '상관없음') || {}).value;
          const anchorValue = (row.data.find(d => d.text === '보통') || {}).value;
          const last = evt[evt.length - 1];

          if(exclusiveValue !== undefined && last === exclusiveValue){
            row.selected = [last];
          } else {
            let candidate = exclusiveValue !== undefined ? evt.filter(v => v !== exclusiveValue) : evt;
            if(candidate.length > 2){
              const lastCandidate = candidate[candidate.length - 1];
              candidate = (anchorValue !== undefined && lastCandidate !== anchorValue && candidate.includes(anchorValue))
                ? [anchorValue, lastCandidate]
                : [lastCandidate];
            } else if(candidate.length === 2 && !candidate.includes(anchorValue)){
              candidate = [candidate[candidate.length - 1]];
              //this.fn_open_alert('보통+갈증적음 또는 보통+갈증많음만 복수 선택이 가능합니다.');
            }
            row.selected = candidate;
          }
          const itemMap = row.data.reduce((map, item) => { map[item.value] = item.text; return map; }, {});
          this.healthSymptoms[idx].label = row.selected.map(v => itemMap[v]).join('+');
        }
        //수면상태 선택시 (양호 일경우 : 다른 항목 disable 그 외는 복수 선택)
        else if(idx === 8){

          const SPECIAL_VALUES = ['GOOD', 'UNKNOWN','STABLE','ANY'];    // 특정 동작을 해야 하는 값
          const nonSpecialSelected = evt.filter(v => !SPECIAL_VALUES.includes(v));   // 특정 값이 아닌 다른 값들이 선택되었는지 확인
          const lastSelected = evt[evt.length - 1];   // 마지막 선택된 값

          // 마지막 선택이 special value면 해당 값만 유지, 아니면 special values 제거
          if (SPECIAL_VALUES.includes(lastSelected)) {
            row.selected = [lastSelected];
          } else {
            row.selected = nonSpecialSelected;
          }


          // 2) A 이외 값은 최대 3개 제한
          const currentNonA = row.selected.filter(v => !SPECIAL_VALUES.includes(v));
          if (currentNonA.length > 3) {
            row.selected = currentNonA.slice(0, 3);
          }

          if(currentNonA.length < 4) {
            let itemMap = row.data.reduce((map, item) => {
              map[item.value] = item.text
              return map
            }, {})

            console.log("===== itemMap : %o", itemMap);

            let selectedTexts = evt.map(value => {
              return itemMap[value];
            })

            console.log("===== selectedTexts : %o", selectedTexts);

            this.healthSymptoms[idx].label = selectedTexts.join();
          }
        }
        // 소화상태: 상관없음은 단독 선택, 나머지 최대 2개
        else if(idx === 11){
          const noneValue = (row.data.find(d => d.text === '상관없음') || {}).value;
          const lastSelected = evt[evt.length - 1];
          if(noneValue && lastSelected === noneValue){
            row.selected = [noneValue];
          } else {
            row.selected = evt.filter(v => v !== noneValue);
          }
          if(row.selected.length > 2){
            row.selected = row.selected.slice(0, 2);
          }
          const itemMap = row.data.reduce((map, item) => { map[item.value] = item.text; return map; }, {});
          this.healthSymptoms[idx].label = row.selected.map(v => itemMap[v]).join('+');
        }
      }else{
        const filteredData = row.data.filter(item => item.value === evt)
        this.healthSymptoms[idx].label = Object.assign(...filteredData).text
      }

      //체질별 영향 변경에 따라 체질활성화 처리
      if(idx === 1){
        if(row.selected == 'A'){
          this.healthSymptoms[2].data.forEach(item => item.disabled = false);
        }else{
          this.healthSymptoms[2].data.forEach(item => item.disabled = true);
          this.healthSymptoms[2].selected = '';
        }
      }

      if(idx === 0) {
        this.scretPrescriptionInfo.gender = row.selected;
      }else if(idx === 1) {
        this.scretPrescriptionInfo.constitutionImpact = row.selected;
      }else if(idx === 2) {
        this.scretPrescriptionInfo.constitution = row.selected;
      }else if(idx === 3){
        this.scretPrescriptionInfo.thermalType = row.selected;
      }else if(idx === 4) {
        this.scretPrescriptionInfo.physicalStatus = row.selected;
      }else if(idx === 5){
        this.scretPrescriptionInfo.tensionStatus = row.selected;
      }else if(idx === 6){
        this.scretPrescriptionInfo.sensitivity = row.selected;
      }else if(idx === 7){
        this.scretPrescriptionInfo.thirstStatus = row.selected;
      }else if(idx === 8){
        this.scretPrescriptionInfo.sleepStatus = row.selected;
      }else if(idx === 9) {
        this.scretPrescriptionInfo.bowelStatus = row.selected;
      }else if(idx === 10) {
        this.scretPrescriptionInfo.residualStoolSense = row.selected;
      }else if(idx === 11) {
        this.scretPrescriptionInfo.digestiveStatus = row.selected;
      }else if(idx === 12) {
        this.scretPrescriptionInfo.appetite = row.selected;
      }
    },
  }
};
</script>
